<template>
  <div class="auth-wrapper-container">
    <div class="auth-card">
      <img src="@assets/img/Default.png" alt="Web Orion Logo" class="logo" />
      <slot />
    </div>
    <div class="copyright">
      <p>
        WebOrion is an innovative creation of Cloudsine Pte Ltd.
        <br />
        All Rights Reserved.
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AuthWrapper',
  };
</script>

<style lang="scss" scoped>
  .auth-wrapper-container {
    width: 100%;
    min-width: 100vw;
    width: 100%;
    min-height: 100vh;
    padding: 30px;
    background-color: #f6f7fa;
    .auth-card {
      width: 400px;
      background-color: #ffffff;
      border-radius: 20px;
      padding: 30px 20px;

      .logo {
        display: block;
        margin:  0 auto;
      }
    }
    .copyright {
      width: 400px;
      p {
        margin-bottom: 0;
        margin-top: 20px;
        color: #858688;
        font-size: 11px;
        line-height: 16px;
        text-align: center;
      }
    }
    .auth-card, .copyright {
      margin: 0 auto;
    }
  }
</style>
